const toNumber = (value) => {
  const n = parseInt(value, 10);
  return Number.isNaN(n) ? 0 : n;
};

export function applyDecisionMark(rows, index, decisionMaking) {
  return rows.map((row, i) => {
    if (i !== index) return row;
    const estimulo = toNumber(row.estimulo);
    const arrival = toNumber(row.arrival);
    const visuMotor = decisionMaking - estimulo;
    const motor = arrival - decisionMaking;
    const cognitiveMotor =
      visuMotor !== 0 && motor !== 0 ? visuMotor + motor : 0;
    return {
      ...row,
      decisionMaking,
      autoComplete: false,
      visuMotor,
      motor,
      cognitiveMotor,
    };
  });
}

export function applyArrivalMark(rows, index, arrival) {
  return rows.map((row, i) => {
    if (i !== index) return row;
    const estimulo = toNumber(row.estimulo);
    const decisionMaking = toNumber(row.decisionMaking);
    const visuMotor = decisionMaking - estimulo;
    const motor = arrival - decisionMaking;
    const previousVisuMotor = toNumber(row.visuMotor);
    const cognitiveMotor =
      previousVisuMotor !== 0 && motor !== 0 ? previousVisuMotor + motor : 0;
    return {
      ...row,
      arrival,
      autoComplete: false,
      visuMotor,
      motor,
      cognitiveMotor,
    };
  });
}

export function resetRows(rows) {
  return rows.map((row) => ({
    ...row,
    decisionMaking: 0,
    arrival: 0,
    visuMotor: 0,
    motor: 0,
    cognitiveMotor: 0,
    error: false,
  }));
}

export function serializeMoves(rows) {
  return rows.map((row, index) => ({
    playID: index + 1,
    error: Boolean(row.error),
    estimulo: String(row.estimulo),
    decisionMaking: String(row.decisionMaking),
    arrival: String(row.arrival),
    visuMotor: String(row.visuMotor),
    motor: String(row.motor),
    cognitiveMotor: String(row.cognitiveMotor),
  }));
}